import http from '../common/http'

export const GetNavigation = (params) => (
    http.get('/PartsInStore/GetPartsNaviagetion', params)
)
//配件入库
export const ImportParts = params => (
    http.post('/PartsInStore/ImportParts', params)
)
//入库记录查询
export const RecordLists = recordInput => (
	http.post('/PartsInStore/GetPartsList', recordInput)
)
//配件编码查询
export const StoreGetOneCode = code => (
	http.get('/PartsInStore/GetOneCode', { code: code })
)

// 获取用户权限门店（维修师和店员权限）内有三方核销的门店
export const GetThirdWriteOffStores = () => (
	http.get('/store/GetThirdWriteOffStores')
)



// WEBPACK FOOTER //
// ./src/api/storeApi.js